module.exports = __webpack_public_path__ + "static/media/Mission_355x237.7f27b740.jpg";